import { loader } from "graphql.macro";

export const ContentQuery = loader("./ContentQuery.graphql");
export const NextEmbedContentQuery = loader("./NextEmbedContentQuery.graphql");
